import { 
	createSlice
} from '@reduxjs/toolkit'

const slice = createSlice({
	name: 'memoRecorder',
	initialState:{show:false},
	reducers: {
		toggleShow : (state)=>{
			state.show = !state.show
		}
	}
})

export const {toggleShow} = slice.actions


export default slice.reducer